import * as React from "react";
import { ProcessingActivitiesDashboardColumn } from "./ProcessingActivitiesDashboardColumn";

export function ProcessingActivitiesRoute(): JSX.Element {
  return <ProcessingActivitiesDashboardColumn />;
}
